import { render } from "./KoreanPancakeBody.vue?vue&type=template&id=4531486d&scoped=true"
import script from "./KoreanPancakeBody.vue?vue&type=script&lang=js"
export * from "./KoreanPancakeBody.vue?vue&type=script&lang=js"

import "./KoreanPancakeBody.vue?vue&type=style&index=0&id=4531486d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4531486d"]])

export default __exports__